import { CompanyInformation } from 'commons/types/DTO/commons'

import { CompanyInformationFormValue } from '../../../../types'

export const mapCompanyInformationForm = ({
  companyID,
  entityUID,
  legalName,
  DBA,
  phone,
  website,
  description,
  historicalExtension
}: CompanyInformationFormValue): CompanyInformation => ({
  companyID: +(companyID ?? 0),
  entityUID,
  legalName,
  DBA,
  phone,
  website,
  description,
  historicalExtension
})
